import {
  EDriverAssignedStatus,
  EDriverStatus,
  IDriversFiltersForm,
  INewDriverStep1,
  INewDriverStep2
} from 'features/Drivers/types'
import { GTDriverSuggestion, GTPartnerSuggestion, GTTDriver, GTTDriverDocumentCategory } from 'gql/types.generated'
import { getQueryString } from 'utils/route'

export const mapFormToMutation = (formValues: TSFixMe): TSFixMe => {
  const mutationValues = {
    ...formValues
  }
  return mutationValues
}

export const getPhoneNumber = (phoneNumber?: { number: string } | null): string => {
  return phoneNumber?.number || ''
}

export const mapDriverToStep1Values = (driver?: GTTDriver): INewDriverStep1 => {
  return {
    firstName: driver?.userAccount.firstName || '',
    lastName: driver?.userAccount.lastName || '',
    partner: {
      id: driver?.partner.id || '',
      name: driver?.partner.name || ''
    },
    phone: getPhoneNumber(driver?.userAccount.phoneNumber),
    email: driver?.userAccount.email || '',
    state: driver?.stateCode || '',
    gender: driver?.userAccount.gender || '',
    type: ''
  }
}
export const mapFiltersToSearchQueryString = (filters: IDriversFiltersForm, pageNb = 1): string => {
  return getQueryString({
    page: pageNb,
    id: filters.driver.id,
    status: filters.status,
    assigned: filters.assigned,
    partnerId: filters.partner.id,
    email: encodeURIComponent(filters.email),
    phoneNumber: filters.phoneNumber
  })
}

export const mapDriverToStep2Values = (driver?: GTTDriver): INewDriverStep2 => {
  const orderedCategories = [
    GTTDriverDocumentCategory.Photo,
    GTTDriverDocumentCategory.Licence,
    GTTDriverDocumentCategory.Id,
    GTTDriverDocumentCategory.BirthCertificate,
    GTTDriverDocumentCategory.ProofOfAddress,
    GTTDriverDocumentCategory.Curp,
    GTTDriverDocumentCategory.ProofOfLastStudy,
    GTTDriverDocumentCategory.Application
  ]
  const documents = driver?.documents ?? []
  const driverDocuments = [...documents].reverse()

  return {
    documents: orderedCategories.map((category) => {
      const driverDocument = driverDocuments.find((document) => document.category === category)
      return {
        category: category,
        file: driverDocument?.document.path ?? '',
        filename: driverDocument?.document.name ?? ''
      }
    })
  }
}

export const mapSearchToFiltersForm = (
  queries: Record<string, string | undefined>,
  { partner, driver }: { partner?: GTPartnerSuggestion; driver?: GTDriverSuggestion }
): IDriversFiltersForm => {
  return {
    email: queries.email || '',
    phoneNumber: queries.phoneNumber || '',
    driver: {
      id: queries.id || '',
      name: driver?.name || ''
    },
    partner: {
      id: queries.partnerId || '',
      name: partner?.name || ''
    },
    status:
      queries.status === EDriverStatus.Active
        ? EDriverStatus.Active
        : queries.status === EDriverStatus.Inactive
        ? EDriverStatus.Inactive
        : '',
    assigned:
      queries.assigned === EDriverAssignedStatus.Assigned
        ? EDriverAssignedStatus.Assigned
        : queries.assigned === EDriverAssignedStatus.Unassigned
        ? EDriverAssignedStatus.Unassigned
        : ''
  }
}
export const mapFiltersToQueryVariables = (filters: IDriversFiltersForm): TSFixMe => {
  return {
    email: filters.email || undefined,
    phoneNumber: filters.phoneNumber || undefined,
    isAssigned:
      filters.assigned === EDriverAssignedStatus.Assigned
        ? true
        : filters.assigned === EDriverAssignedStatus.Unassigned
        ? false
        : undefined,
    isEnabled:
      filters.status === EDriverStatus.Active ? true : filters.status === EDriverStatus.Inactive ? false : undefined,
    id: filters.driver.id || undefined,
    partnerID: filters.partner.id || undefined
  }
}
